__turbopack_context__.v({
  "className": "inter_2602f946-module__2PEFoa__className",
  "variable": "inter_2602f946-module__2PEFoa__variable",
});
